import React, { useEffect } from "react";
import { ErrorBoundary } from "../../bugsnag";
import ErrorView from "../ErrorView";
import { ThemeProvider } from "@mui/material";
import theme from "../../theme";
import { SnackbarProvider } from "notistack";
import { APIContext } from "../../contexts/apiContext";
import Importer from "./Importer";

const App = (props: { cartId: string }) => {
  return (
    <ErrorBoundary FallbackComponent={ErrorView}>
      <ThemeProvider theme={theme}>
        <SnackbarProvider
          domRoot={document.querySelector("body")}
          anchorOrigin={{ horizontal: "center", vertical: "top" }}
        />
        <APIContext.Provider
          value={{
            baseUrl: window.si.apiUrl,
            currencyCode: Shopify.currency.active,
            shipToCountryCode: Shopify.country,
            locale: "en-GB",
            storeHash: window.si.apiUrl,
          }}
        >
          <Importer cartId={props.cartId} />
        </APIContext.Provider>
      </ThemeProvider>
    </ErrorBoundary>
  );
};

export default App;
